import { CommonModule } from '@angular/common';
import { Component,  Input, Output, EventEmitter } from '@angular/core';
import { TrafficLightComponent } from '../misc/traffic-light.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@Component({
    selector: 'title-status-toggle',
    template: `
<div class="wrapper" [ngClass]="{ pale: !!hideToggle }">
  <div class="header">
    <h3 [ngClass]="{ dim: !!hideToggle }">{{ title }}</h3>
    <div style="flex:1"></div>
    <ng-content select=".afterTitle"></ng-content>
    <traffic-light 
      [color]="statusColor" 
      [dim]="!!hideToggle"
      [text]="status">
    </traffic-light>
    <div class="toggle-holder">
      <div class="toggle-text" [ngClass]="{ dim: !!hideToggle }" *ngIf="!hideToggle && toggleStates[toggleOn ? 1 : 0] as text" [ngClass]="{selected: toggleOn}">{{ text }}</div>
      <mat-slide-toggle *ngIf="!hideToggle" [ngClass]="{ selected: toggleOn }" (change)="toggle.emit(!toggleOn)" [checked]="toggleOn"></mat-slide-toggle>
    </div>
  </div>
</div>
`,
    styleUrls: ['./title-toggle-wrapper.scss'],
    standalone: true,
    imports: [CommonModule, TrafficLightComponent, MatSlideToggleModule],
})
export class TitleStatusToggleComponent {
  @Input() title: string
  @Input() status: string
  @Input() statusColor: string

  @Input() toggleOn = false
  @Input() hideToggle = false
  @Input() toggleStates = ['OFF', 'ON']
  @Output() toggle: EventEmitter<boolean> = new EventEmitter()

}




